const DEFAULT_CALENDAR_TITLE = '齊文活動月曆';
const DEFAULT_SITE_SUFFIX = '齊文活動月曆';

function upsertMeta(attrName, attrValue, property) {
  if (typeof document === 'undefined') return;
  const key = property ? 'property' : 'name';
  const selector = `meta[${key}="${attrName}"]`;
  let el = document.head.querySelector(selector);
  if (!attrValue) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(key, attrName);
    document.head.appendChild(el);
  }
  el.setAttribute('content', attrValue);
}

/**
 * @param {{ title?: string, description?: string, image?: string, url?: string }} meta
 */
export function applyActivityShareMeta(meta) {
  if (typeof document === 'undefined') return;
  const activityTitle = String(meta?.title || '').trim();
  const fullTitle = activityTitle || DEFAULT_CALENDAR_TITLE;
  document.title = activityTitle ? `${activityTitle} | ${DEFAULT_SITE_SUFFIX}` : DEFAULT_CALENDAR_TITLE;

  const desc = String(meta?.description || '').trim()
    || (activityTitle ? `${activityTitle} — ${DEFAULT_SITE_SUFFIX}` : DEFAULT_CALENDAR_TITLE);
  const url = String(meta?.url || '').trim() || (typeof window !== 'undefined' ? window.location.href : '');
  const image = String(meta?.image || '').trim();

  upsertMeta('description', desc, false);
  upsertMeta('og:type', 'website', true);
  upsertMeta('og:title', activityTitle || DEFAULT_CALENDAR_TITLE, true);
  upsertMeta('og:description', desc, true);
  upsertMeta('twitter:card', image ? 'summary_large_image' : 'summary', false);
  upsertMeta('twitter:title', activityTitle || DEFAULT_CALENDAR_TITLE, false);
  upsertMeta('twitter:description', desc, false);
  if (url) upsertMeta('og:url', url, true);
  if (image) {
    upsertMeta('og:image', image, true);
    upsertMeta('twitter:image', image, false);
  } else {
    upsertMeta('og:image', '', true);
    upsertMeta('twitter:image', '', false);
  }
}

export function resetActivityShareMeta() {
  applyActivityShareMeta({});
}
